"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SavedIdViewState = /** @class */ (function () {
    function SavedIdViewState() {
        this.disabled = false;
        this.displaySaveUserIDList = [];
        this.passwordValue = '';
        this.isPasswordinValid = false;
        this.passwordErrorMessage = '';
        this.userID = '';
        this.isUserIDSelected = false;
        this.savedUserID = false;
        this.showRemoveSaveIdModal = false;
        this.errorMessage = '';
        this.errorMessageCounter = 0;
        this.errormessagePasswordComponent = '';
    }
    return SavedIdViewState;
}());
exports.default = SavedIdViewState;
//# sourceMappingURL=SavedIdViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/SavedIdViewState.js
// module id = 1502
// module chunks = 8